import { render, staticRenderFns } from "./SaveDetail.vue?vue&type=template&id=5f6605ec&scoped=true&"
import script from "./SaveDetail.vue?vue&type=script&lang=ts&"
export * from "./SaveDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SaveDetail.vue?vue&type=style&index=0&id=5f6605ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6605ec",
  null
  
)

export default component.exports